import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const ContactUs = () => (
  <section className="py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16 space-y-4">
        <h2 className="text-4xl lg:text-5xl font-bold text-red-900">
          Get in Touch
        </h2>
        <p className="text-xl text-red-700 max-w-3xl mx-auto">
          Have questions? We'd love to hear from you. Send us a message and
          we'll respond as soon as possible.
        </p>
      </div>
      <div className="grid lg:grid-cols-2 gap-12">
        <div className="space-y-8">
          <h3 className="text-2xl font-bold text-red-900">
            Contact Information
          </h3>
          <div className="space-y-6">
            <div className="flex items-center space-x-5 p-6 bg-gradient-to-r from-red-50 to-red-100 rounded-2xl">
              <div className="flex-shrink-0 w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-md">
                <Mail className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <p className="text-sm font-semibold text-red-500 mb-1">Email</p>
                <p className="text-lg font-semibold text-red-900">
                  support@menuqr.com
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-5 p-6 bg-gradient-to-r from-red-50 to-red-100 rounded-2xl">
              <div className="flex-shrink-0 w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-md">
                <Phone className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <p className="text-sm font-semibold text-red-500 mb-1">Phone</p>
                <p className="text-lg font-semibold text-red-900">
                  +1 (555) 123-4567
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-5 p-6 bg-gradient-to-r from-red-50 to-red-100 rounded-2xl">
              <div className="flex-shrink-0 w-14 h-14 bg-white rounded-xl flex items-center justify-center shadow-md">
                <MapPin className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <p className="text-sm font-semibold text-red-500 mb-1">
                  Address
                </p>
                <p className="text-lg font-semibold text-red-900">
                  123 Business St, Suite 100
                  <br />
                  San Francisco, CA 94105
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-red-50 to-red-100 p-10 rounded-3xl shadow-xl">
          <h3 className="text-2xl font-bold text-red-900 mb-8">
            Send us a message
          </h3>
          <form className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-red-700 mb-2">
                Name
              </label>
              <input
                type="text"
                className="w-full px-5 py-4 bg-white border-2 border-red-200 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
                placeholder="Your name"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-red-700 mb-2">
                Email
              </label>
              <input
                type="email"
                className="w-full px-5 py-4 bg-white border-2 border-red-200 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
                placeholder="your@email.com"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-red-700 mb-2">
                Message
              </label>
              <textarea
                rows={5}
                className="w-full px-5 py-4 bg-white border-2 border-red-200 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all resize-none"
                placeholder="Your message"
              />
            </div>
            <button
              type="submit"
              className="w-full px-8 py-4 bg-gradient-to-r from-red-600 to-red-400 text-white text-base font-semibold rounded-xl hover:from-red-700 hover:to-red-500 transition-all duration-200 shadow-lg shadow-red-600/30"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
);

export default ContactUs;
